"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reports = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const admin_context_1 = require("@src/components/pages/admin/admin-context");
const react_router_dom_1 = require("react-router-dom");
const premium_subscription_1 = require("@src/helpers/premium-subscription");
const ReportSection_1 = __importDefault(require("./ReportSection"));
const ReportCard_1 = require("./ReportCard");
const Reports = () => {
    const intl = (0, react_intl_1.useIntl)();
    const history = (0, react_router_dom_1.useHistory)();
    const { companyInfo } = (0, admin_context_1.useAdminContextValue)();
    const hasActivePremiumSubscription = (0, premium_subscription_1.getHasCompanyActivePremiumCompanyProfileSubscription)(companyInfo.companyPaymentSubscriptions);
    react_1.default.useEffect(() => {
        if (!hasActivePremiumSubscription) {
            history.pushLocalized('/admin');
        }
    }, [companyInfo.companyPaymentSubscriptions]);
    return ((0, jsx_runtime_1.jsxs)(elements_1.AdminPageContainer, { title: intl.formatMessage({
            id: 'admin.analytics.reports',
        }), description: intl.formatMessage({
            id: 'admin.analytics.reports_description',
        }), children: [(0, jsx_runtime_1.jsxs)(ReportSection_1.default, { title: intl.formatMessage({
                    id: 'general.offers',
                }), children: [(0, jsx_runtime_1.jsx)(ReportCard_1.ReportCard, { analyticsType: types_1.AnalyticsType.applications_per_offer }), (0, jsx_runtime_1.jsx)(ReportCard_1.ReportCard, { analyticsType: types_1.AnalyticsType.applications_per_day })] }), (0, jsx_runtime_1.jsx)(ReportSection_1.default, { title: intl.formatMessage({
                    id: 'admin.analytics.company_profile',
                }), children: (0, jsx_runtime_1.jsx)(ReportCard_1.ReportCard, { analyticsType: types_1.AnalyticsType.accumulated_company_subscribers }) })] }));
};
exports.Reports = Reports;
